module.exports = __webpack_public_path__ + "img/back.84647064.svg";